import logger from "logging/logger";
import { QueryClient, setLogger } from "react-query";
import { sendGetRequest } from ".";

setLogger({
  log: logger.log,
  warn: logger.warn,
  error: logger.warn,
});
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      // eslint-disable-next-line consistent-return
      queryFn: async ({ queryKey: [endpoint] }) => {
        if (typeof endpoint === "string") {
          const response = await sendGetRequest<IGenericAPIResponse>(endpoint);

          if (response.isSuccess) {
            return response;
          }

          throw new Error(response.error ?? response.message);
        }
      },
    },
  },
});
